.s-progress-bar{
  &-header{
  }
  &-target-section {
  }

  &-container {
  }

  &-wrapper {
  }

  &-progress {
  }

  &-message {
  }
}
